























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class PrintThead extends Vue {
	@Prop({ type: String })
	title!: string;
	@Prop({ type: String })
	period!: string;
}
